
import { Component, Vue } from "vue-property-decorator";
import BackgroundLoader from "@/components/Common/BackgroundLoader.vue";
import MenuIngenieria from "@/components/Menus/MenuIngenieria.vue";
import MenuPrincipal from "@/components/Menus/MenuPrincipal.vue"; 

@Component({
  components: {
    BackgroundLoader,
    MenuPrincipal,
    MenuIngenieria,
  }
})
export default class IngenieriaPlayer extends Vue {

  mounted() {
    // console.log("IngenieriaPlayer mounted " + this.$store.state.mainState + " " + this.$store.state.ingenieriaState)
  }

  frameFondo = "2_0_ingenieria.svg";

  textoIngenieria = `El área de Ingeniería Civil está formada por profesionales Ingenieros de Caminos e Ingenieros Técnicos de Obras Públicas, con más de 14 años de experiencia proyectando, gestionando, dirigiendo y construyendo todo tipo de obras civiles.
      <br/><br/>
      Algunas obras de referencia desarrolladas por nuestros técnicos son:`;

 }

